module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_6000.db0e584d.png";